import { render, staticRenderFns } from "./ListFields.vue?vue&type=template&id=83872a38&scoped=true"
import script from "./ListFields.vue?vue&type=script&lang=js"
export * from "./ListFields.vue?vue&type=script&lang=js"
import style0 from "./ListFields.vue?vue&type=style&index=0&id=83872a38&prod&scoped=true&lang=css"
import style1 from "./ListFields.vue?vue&type=style&index=1&id=83872a38&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83872a38",
  null
  
)

export default component.exports